
import Vue from 'vue'
import axios from '@/axios'

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(ToastPlugin,{position: 'middle'})
Vue.use(LoadingPlugin,{position: 'middle'})

import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'


const u = navigator.userAgent;
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; 

/***
* @method uploadFiles
* @param {file} file 文件
*/
const uploadFiles = (formData) => {
let config = {
headers: {'Content-Type': 'multipart/form-data'}
}
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/file/v1/upload',formData,config).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 关于我们
* @method aboutUs
* @return {object} {code:0,msg:'',data:{}}
*/
const aboutUs = () => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/sys/v1/about').then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 获取注册协议
* @method getProtocol
* @return {object} {code:0,msg:'',data:{}}
*/
const getProtocol = () => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/sys/v1/rprotocol').then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 验证手机号
* @param {string} dataObj 手机号
* @return {object} {code:0,msg:'',data:{}}
*/
const checkPhone = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '检验号码中',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/sms/v1/checkmobile',{
mobile:dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 获取验证码
* @method getSMS
* @param {string} dataObj 手机号
* @return {object} {code:0,msg:'',data:{}}
*/
const getSMS = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/sms/v1/getcode',{
mobile:dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 检验验证码和手机号是否正确
* @method checkPhoneAndSMS
* @param {string} phone 手机号、验证码
* @param {string} code 验证码
* @return {object} {code:0,msg:'',data:{}}
*/
const checkPhoneAndSMS = (phone,code) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/sms/v1/checkcode',{
mobile:phone,
smscode:code
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
*登录
* @method login
* @param {string} mobile
* @param {string} smscode
* @return {object} {code:0,msg:'',data:{}}
*/
const login = (phone,code) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/user/v1/fast/login',{
mobile:phone,
smscode:code,
devicetype:3
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 密码登录
* @method pwdLogin
* @param {string} mobile
* @param {string} password
* @return {object} {code:0,msg:'',data:{}}
*/
const pwdLogin = (phone,pwd) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/user/v1/login',{
mobile:phone,
password:pwd,
devicetype:3
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/***
* 微信登录
* @method wxlogin
* @param mobile
* @param smscode
* @param devicetype
* @param devicetoken
* @param code
*/
const wxlogin = (code) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/weixin/v1/weixinLogin',{
code:code,
flag:1
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 忘记密码
* @method forget
* @param {string} mobile
* @param {string} password
* @param {string} smscode
* @return {object} {code:0,msg:'',data:{}}
*/
const forget = (phone,code,pwd) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/user/v1/forgetPwd',{
mobile:phone,
password:pwd,
smscode:code
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 注册
* @method register
* @param {string} mobile
* @param {string} password
* @param {string} smscode
* @return {object} {code:0,msg:'',data:{}}
*/
const register = (phone,code,pwd) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/user/v1/register',{
mobile:phone,
password:pwd,
smscode:code
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}


/***
* 绑定手机号
* @method bindPhone
* @param mobile
* @param smscode
* @param unionId
* @param openId
* @param deviceType
*/
const bindPhone = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/weixin/v1/weixinValidate',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}




/**
* 获取国家编码
* @method countryCode
* @return {object} {code:0,msg:'',data:{}}
*/
const countryCode = () => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/unit/v1/nationlist').then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 获取视频相关信息
* @method videoDetail
* @param {string} vid 视频id
* @return {object} {code:0,msg:'',data:{}}
*/
const videoDetail = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/video/v1/detail',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}


/**
* 获取微信参数
* @method wxApi
* @param {string} url #之前的地址
* @return {object} {code:0,msg:'',data:{}}
*/
const wxApi = () => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/jssdk/v1/config',{
url:window.location.href.split('#')[0]
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/***
* 根据视频id获取视频地址
* @method videoUrl
* @param {string} videoId 视频id
* @return {object} {code:0,msg:'',data:{}}
*/
const videoUrl = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/video/v1/getPlayVideoURL',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 随机获取视频
* @method randomVideo
* @return {object} {code:0,msg:'',data:{}}
*/
const randomVideo = () => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/video/v1/randomvideolist').then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}



/**
* 获取线路信息
* @method lineDetail
* @param {string} rid 路线id
* @return {object} {code:0,msg:'',data:{}}
*/
const lineDetail = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/route/v1/getRouteInfoById',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 获取行程详情
* @method lineDetailDesc
* @param {string} rid 路线id
* @return {object} {code:0,msg:'',data:{}}
*/
const lineDetailDesc = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/release/v1/infoList',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 获取换套餐线路
* @method linePackage
* @param {string} rid 路线id
* @return {object} {code:0,msg:'',data:{}}
*/
const linePackage = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/routemeal/v1/infoList',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}


/**
* 个人推荐
* @method recommandList
* @param {string} uid 用户id
* @return {object} {code:0,msg:'',data:{}}
*/
const recommandList = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/route/v1/forYouRecommend',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}


/**
* 根据用户id获取详细信息
* @method guideDetail
* @param {string} uid 用户id
* @return {object} {code:0,msg:'',data:{}}
*/
const guideDetail = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/tourist/v1/getTouristOrCompanyDetail',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}


/**
* 商品列表
* @method goodsList
* @param {string} uid 用户id
* @param {string} flag
* @param {string} pageno 当前页码
* @param {string} ulstatus
* @return {object} {code:0,msg:'',data:{}}
*/
const goodsList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/route/v1/list',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 获取用户信息
* @method getUserInfo
* @param {string} uid 用户id
* @return {object} {code:0,msg:'',data:{}}
*/
const getUserInfo = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/user/v1/userinfoH5',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 根据旅享id获取用户信息
* @method getLxCodeUserInfo
* @param {string} lxCode 旅享id
* @return {object} {code:0,msg:'',data:{}}
*/
const getLxCodeUserInfo = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/user/v1/getUserInfoByLxCode',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}


/***
* 视频列表
* @method getVideoList
* @param {string} uid 用户id
* @param {string} keywords 关键字
* @param {string} count 每页数量
* @param {string} pageno 当前页数
* @return {object} {code:0,msg:'',data:{}}
*/
const getVideoList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/list',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 导游列表
* @method guideList
* @param {string} cid 城市id
* @param {string} count 每页数量
* @param {string} pageno 当前页数
* @return {object} {code:0,msg:'',data:{}}
*/
const guideList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/tourist/v1/getAllList',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 获取旅游类型
* @method travelType
* @return {object} {code:0,msg:'',data:{}}
*/
const travelType = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/routetype/v1/detail',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 根据类型获取城市列表
* @method travelList
* @param {string} cid 城市id
* @param {string} typeid 城市类型id
* @param {string} count 每页数量
* @param {string} pageno 当前页数
* @return {object} {code:0,msg:'',data:{}}
*/
const travelList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/route/v1/list',{
flag:1,
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 定位
*/
const local = () => {
return new Promise((resolve,reject) => {
const geolocation = new BMap.Geolocation();
geolocation.getCurrentPosition(function(r){
if(this.getStatus() == BMAP_STATUS_SUCCESS){
console.log('您的位置：'+r.point.lng+','+r.point.lat);
let cityData = ChinaAddressV4Data.find(ele => ele.name == r.address.city);
r.cityCode = cityData.value;
resolve(r)
}
else {
console.log('failed'+this.getStatus());
reject('定位失败')
}
});
})
}


/**
* 国内城市列表
* @method inSideCityList
* @return {object} {code:0,msg:'',data:{}}
*/
const inSideCityList = () => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/unit/v1/internal/citylist').then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}


/**
* 境外国家列表
* @method outSideCountyList
* @param {string} continent 洲id
* @return {object} {code:0,msg:'',data:{}}
*/
const outSideCountyList = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/unit/v1/foreign/countrylist',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}
/**
* 境外城市列表
* @method outSideCityList
* @param {string} hot 1
* @return {object} {code:0,msg:'',data:{}}
*/
const outSideCityList = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/unit/v1/foreign/citylist',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}


/**
* 获取游客列表
* @method getTouristList
* @return {object} {code:0,msg:'',data:{}}
*/
const getTouristList = () => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/follow/v1/getFollowInfo').then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/**
* 保存游客
* @method actTourist
* @param {string}  followId
* @param {string} type
* @param {string} name
* @param {string} cardType
* @param {string} card
* @return {object} {code:0,msg:'',data:{}}
*/
const actTourist = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/follow/v1/save',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/**
* 删除游客
* @method actTourist
* @param {string}  followId
* @return {object} {code:0,msg:'',data:{}}
*/
const delTourist = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/follow/v1/delete',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/**
* 下单
* @method actTourist
* @param {string}  touristCompanyId 导游或企业ID
* @param {string}  touristCompanyName 导游或企业名称
* @param {string}  channelType 渠道类型 1:线路、2:景点、3:导游、4:特产
* @param {string}  channelId 渠道ID
* @param {string}  channelName 渠道名称
* @param {string}  channelImage 渠道图片
* @param {string}  mealId 套餐ID
* @param {string}  mealName 套餐名称
* @param {string}  mealTime 套餐时间
* @param {string}  mealDetailId 套餐明细ID
* @param {string}  tripNumber 行程天数
* @param {string}  sumCount 总订单数
* @param {string}  adultCount 成人订单数
* @param {string}  childrenCount 儿童订单数
* @param {string}  adultPrice 成人票价
* @param {string}  childrenPrice 儿童票价
* @param {string}  orderAmountTotal 总票价
* @param {string}  linkName 联系人
* @param {string}  linkMobile 联系电话
* @param {string}  linkMail 联系人邮箱
* @param {string}  followIds 跟随游客ID
* @param {string}  mark 买家留言
* @return {object} {code:0,msg:'',data:{}}
*/
const submitOrder = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/save',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/**
* 获取订单详情
* @method orderDetail
* @param {string}  outTradeNo
* @return {object} {code:0,msg:'',data:{}}
*
*/
const orderDetail = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/getOrderByOutTradeNo',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/**
* 获取订单详情2
* @method orderDetail2
* @param {string}  outTradeNo
* @param {string}  channelType 渠道类型 ：1:线路、2:商城、5:定制线路
* @return {object} {code:0,msg:'',data:{}}
*
*/
const orderDetail2 = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/getOrderByOutTradeNo2',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/**
* 获取首页列表
* @method indexList
* @param {string}  flag //	标识 1：时尚 2：频道 3：文旅 4：时尚
* @return {object} {code:0,msg:'',data:{}}
*
*/
const indexList = (dataObj) => {

return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/getVideoInfoByType',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 获取相关视频
* @method relatedVideo
* @param {string}  flag //	标识 1：时尚 2：频道 3：文旅
* @return {object} {code:0,msg:'',data:{}}
*/
const relatedVideo = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/getRelatedVideoInfo',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/**
* 评论内容
* @method getCommit
* @param {string} vid 视频id
* @return {object}
*/
const getCommit =  (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/review/list',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 评论
* @method commitSubmit
* @param {string} vid 视频id
* @param {string} content 评论内容
* @return {object}
*/
const commitSubmit =  (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/review',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/**
* 喜欢某个视频
* @method videoLike
* @param {string} vid 视频id
*/
const videoLike =  (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/good',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}


/**
* 评论点赞
* @method commitLike
* @param {string} reviewid 评论id
* @return {object}
*/
const commitLike =  (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/review/good',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}


/**
* 关注某人
* @method follow
* @param {String} uid
* @param {String} oper 1 关注 0 取消关注
*/
const followUser = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/fans/v1/follow',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/**
* 获取订单列表
* @method getOrderList
* @param {string} orderStatus 订单状态 (0：未付款,1：商家确定,2：商家拒绝 3：已付款，4：已发货（出发中）, 5：已签收（已完成）, 6：退货申请, 7：退货中, 8：已退货(退款), 9：拒绝退款，10：取消交易, 11：已评价)
*/
const getOrderList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/getOrderList',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 获取订单详情
* @method getOrderDetail
* @param {string} outTradeNo 商家订单号
*/
const getOrderDetail = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/getOrderByOutTradeNo',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 获取订单详情2
* @method getOrderDetail2
* @param {string} outTradeNo 商家订单号
*/
const getOrderDetail2 = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/getOrderByOutTradeNo2',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/***
* 视频列表
* @method getCircle
* @param {string} uid 用户id
* @param {string} count 每页数量
* @param {string} pageno 当前页数
* @return {object} {code:0,msg:'',data:{}}
*/
const getCircle = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/getFriendVideoInfo',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/***********************/
/*****   私人定制   ****/
/**********************/

/***
* 获取景点列表
* @method viewpointList
*
* @return {Object}
*/
const viewpointList = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/scenery/v1/list',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/***
* 获取旅游主题
* @method themeList
*
* @return {Object}
*/
const themeList = (dataObj) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/scenery/v1/travelist',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide();

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide();

reject(err)
})
})
}

/***
* 定制保存
* @method customeSubmit
* @param {string} touristCompanyId 导游或企业ID
* @param {string} touristCompanyName 导游或企业名称
* @param {string} sumCount 总订单数
* @param {string} adultCount 成人订单数
* @param {string} tripPeople 出行人
* @param {string} travelCycle 旅行周期
* @param {string} travelTheme 旅行主题（多个主题之间用逗号分开）
* @param {string} tripBudget 出行预算
* @param {string} linkMobile 联系电话
* @param {string} linkMail 联系人邮箱
* @param {string} fromTime 出发时间
* @param {string} fromCity 出发城市
* @param {string} planeType 飞机类型 0:默认 1:不含机票 2:经济舱 3:商务舱
* @param {string} hotelType 酒店/民宿类型 0:默认 1:舒适型 2:经济型 3:豪华型
* @param {string} vehicleType 车辆类型 0:默认1:四人座 2:六人做
* @param {string} mealType 用餐类型 0:默认：1:包早餐 2:包晚餐 3:自点自付
* @param {string} mark 备注
* @return {Object}
*/
const customeSubmit = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/customized/save',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 活动优惠券列表
* @method activityTicketList
* @param {string} activityId 活动ID
* @return {Object}
*/
const activityTicketList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/share/v1/activityList',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 领取优惠券
* @method receiveTicket
* @param {string} couponCode 优惠券编号
* @return {Object}
*/
const receiveTicket = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/coupon/v1/receive',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 获取活动详情
* @param {string} activityId 活动ID
* @return {Object}
*/

const activityDetail = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/share/v1/getActivity',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/***
* 获取评论列表
* @method commitList
* @param {string} channelId
* @param {string} pageno
* @return {Object}
*/
const commitList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/ordercomment',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/***
* 获取退订规则列表
* @method refundRuleList
* @param {string} uid
* @return {Object}
*/
const refundRuleList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/returnRule/v1/get',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 退款时获取退款规则
* @method refundRule
* @param {string} outTradeNo
* @param {string} productId
* @param {string} touristCompanyId
* @return {Object}
*/
const refundRule = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/refundRate',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 退款操作
* @method refundAction
* @param {string} outTradeNo
* @param {string} pics
* @param {string} returnResult
* @param {string} returnCharge
* @param {string} returnsAmount
* @param {string} deductAmount
* @param {string} returnRule
* @return {Object}
*/
const refundAction = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/applyRefund',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 删除订单
* @method delOrder
* @param {string} outTradeNo
* @return {Object}
*/
const delOrder = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/deleteOrder',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 订单评价
* @method commitOrder
* @param {string} userId
* @param {string} channelId
* @param {string} outTradeNo
* @param {string} storeCommentGrade 店铺（描述相符）评价等级 1：非常不满意 2：不满意 3：满意 4：比较满意 5：非常满意
* @param {string} storeLogisticsGrade 店铺（物流服务）评价等级 1：非常不满意 2：不满意 3：满意 4：比较满意 5：非常满意
* @param {string} storeAttitudeGrade 店铺（服务态度）评价等级 1：非常不满意 2：不满意 3：满意 4：比较满意 5：非常满意
* @param {string} storeCommentContent 店铺评价内容
* @param {string} anonymousComment 商品是否匿名评价 1：匿名 2：不匿名
* @param {string} goodsCommentGrade 商品评价等级 1：非常不满意 2：不满意 3：满意 4：比较满意 5：非常满意
* @param {string} goodsCommentContent 商品评价内容
* @param {string} goodsCommentImages 商品评价图片
* @return {Object}
*/
const commitOrder = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/insertComment',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 微信支付
* @method preOrder
* @param {string} channelName 渠道名称
* @param {string} outTradeNo 商户订单号
* @param {string} totalAmount 支付金额
* @param {string} openId
* @param {number} flag 3
* @return {object} {code:0,msg:'',data:{}}
*/
const preOrder = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/weixin/v1/weixinPay',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 支付宝
* @method alipay
* @param {string} channelName 渠道名称
* @param {string} outTradeNo 商户订单号
* @param {string} totalAmount 支付金额
* @return {object} {code:0,msg:'',data:{}}
*/
const alipay = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/alipay/v1/alipayH5Pay',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 获取文旅、时尚详情
* @method getVideoDetail
* @param {string} vid 视频id
* @return {object} {code:0,msg:'',data:{}}
*/
const getVideoDetail = (dataObj) => {
return new Promise((resolve,reject) => {
Vue.$vux.loading.show({
text: '请稍等',
position: 'middle'
})
axios.post('/lxdspservice/app/ssl/video/v1/detail',{
...dataObj
}).then(res => {
Vue.$vux.loading.hide()

resolve(res)
}).catch(err => {
Vue.$vux.loading.hide()

reject(err)
})
})
}

/**
* 导游资料
* @method getGuideList
* @param {string} pageno 当前页
* @param {string} keywords 搜索关键字
* @return {object} {code:0,msg:'',data:{}}
*/
const getGuideList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/tourist/v1/getTouristDetailPartner',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 导游入驻资料
* @method getGuideEnterList
* @param {string} pageno 当前页
* @param {string} keywords 搜索关键字
* @param {string} checkstate 审核状态 2 审核中 1 审核通过 0 审核失败
* @return {object} {code:0,msg:'',data:{}}
*/
const getGuideEnterList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/tourist/v1/getTouristPartner',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 公司资料
* @method getCompanyList
* @param {string} pageno 当前页
* @param {string} keywords 搜索关键字
* @return {object} {code:0,msg:'',data:{}}
*/
const getCompanyList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/company/v1/getCompanyDetailPartner',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 公司入驻资料
* @method getCompanyEnterList
* @param {string} pageno 当前页
* @param {string} keywords 搜索关键字
* @param {string} checkstate 审核状态 2 审核中 1 审核通过 0 审核失败
* @return {object} {code:0,msg:'',data:{}}
*/
const getCompanyEnterList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/company/v1/getCompanyPartner',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 线路资料
* @method getLineList
* @param {string} pageno 当前页
* @param {string} keywords 搜索关键字
* @param {string} ulstatus 上下架状态 0:下架(待上架) 1:上架（出售中）2：已下架
* @return {object} {code:0,msg:'',data:{}}
*/
const getLineList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/route/v1/getRoutePartnerList',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 订单列表
* @method getPartnerOrderList
* @param {string} pageno 当前页
* @param {string} keywords 搜索关键字
* @param {string} orderStatus 订单状态 (0：未付款,1：商家确定（定制线路商家确定）,2：商家拒绝 3：已付款，4：已发货（出发中）, 5：已签收（已完成）,6：退货申请, 7：退货中, 8：已退货(退款), 9：拒绝退款，10：取消交易, 11：已评价)
* @return {object} {code:0,msg:'',data:{}}
*/
const getPartnerOrderList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/getBusinessParnerOrderList',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 退款列表
* @method getPartnerRefundList
* @param {string} pageno 当前页
* @param {string} keywords 搜索关键字
* @param {string} orderStatus 订单状态 (0：未付款,1：商家确定（定制线路商家确定）,2：商家拒绝 3：已付款，4：已发货（出发中）, 5：已签收（已完成）,6：退货申请, 7：退货中, 8：已退货(退款), 9：拒绝退款，10：取消交易, 11：已评价)
* @return {object} {code:0,msg:'',data:{}}
*/
const getPartnerRefundList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/queryRefundParnerList',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 提现列表
* @method getPartnerWithdrawList
* @param { string } pageno 当前页
* @param { string } count 每页条数
* @param { string } status 提现状态, 0：未提现 1：申请提现 2：已提现(交易完成)
* @param { string } channelType 渠道类型 1:线路、2:景点、3:导游、4:特产 、5：定制线路
* @returns {object}
*/
const getPartnerWithdrawList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/withdraw/v1/getWithdrawalParnerList',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 省列表
* @method getProvinceList
* @returns {object}
*/
const getProvinceList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/unit/v1/provincelist',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 城列表
* @method getCityList
* @param { string } pid 省id
* @returns {object}
*/
const getCityList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/unit/v1/citylist',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 收货地址列表
* @method getMyAddressList
* @param { string } defaultStatus 默认地址（为空代表所有状态） 1：是 2：否
* @returns {object}
*/
const getMyAddressList = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/address/v1/list',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 删除地址
* @method delAddress
* @param { string } addressId 收货人地址ID
* @returns {object}
*/
const delAddress = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/address/v1/deleteAddress',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 保存或者编辑地址
* @method editAddress
* @param { string } addressId 收货人地址ID
* @param { string } realName 收件人姓名
* @param { string } telphone 联系电话
* @param { string } type 	类型：1 境内 2 境外
* @param { string } provinceId 省份ID(填写外国国家ID号)
* @param { string } provinceName 省份名称(填写外国国家名称)
* @param { string } cityId 城市ID
* @param { string } cityName 城市名称
* @param { string } street 地区,街道/详细收货地址
* @param { string } defaultStatus 默认地址 1：是 2：否
* @returns {object}
*/
const editAddress = (dataObj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/address/v1/addOrEdit',{
...dataObj
}).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 商品列表
* @method goodsAllList
* @param {string} pageno 页数
* @param {string} status 推荐状态：0：默认不推荐 1：推荐
* @param {string} ulstatus 上下架状态 0:待上架 1:上架（出售中）2：已下架
* @param {string} goodsType 商品类型ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const goodsAllList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/good/v1/shopperList',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 用户商品列表
* @method userGoodsAllList
* @param {string} pageno 页数
* @param {string} status 推荐状态：0：默认不推荐 1：推荐
* @param {string} ulstatus 上下架状态 0:待上架 1:上架（出售中）2：已下架
* @param {string} goodsType 商品类型ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const userGoodsAllList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/good/v1/list',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 商品详情
* @method goodsDetail
* @param {string} goodsNo 商城编码
* @return {object} {code:0,msg:'',data:{}}
*
*/
const goodsDetail = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/good/v1/goodsDetail',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}



/**
* 商品套餐列表
* @method goodsPackageList
* @param {string} goodsNo 商品编码
* @return {object} {code:0,msg:'',data:{}}
*
*/

const goodsPackageList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/goodsmeal/v1/list',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 为您推荐商品
* @method recommendGoods
* @param {string} uid 用户ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const recommendGoods = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/good/v1/forYouRecommend',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 商品详情列表
* @method goodsDetailList
* @param {string} goodsNo 商城编号
* @return {object} {code:0,msg:'',data:{}}
*
*/

const goodsDetailList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/goodsdetail/v1/list',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 商品详情列表
* @method goodsOrderSubmit
* @param {string} touristCompanyId 导游企业ID
* @param {string} touristCompanyName 导游企业名称
* @param {string} goodsNo 商品编号
* @param {string} goodsName 商品名称
* @param {string} channelImage 商品图片
* @param {string} goodsPrice 商品价格
* @param {string} goodsModeDesc 商品型号信息
* @param {string} goodsModeparams 商品参数信息
* @param {string} number 购买数量
* @param {string} subtotal 小计金额
* @param {string} consigneeRealname 收货人姓名
* @param {string} consigneeTelphone 联系电话
* @param {string} consigneeAddress 收货地址
* @param {string} logisticsFee 物流发货运费(显示给客户的订单运费)
* @param {string} mark 	留言
* @return {object} {code:0,msg:'',data:{}}
*
*/

const goodsOrderSubmit = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/goods/save',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 物流公司列表
* @method logisticsCompany
* @return {object} {code:0,msg:'',data:{}}
*
*/

const logisticsCompany = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/orderLogistics/v1/getExpressDeliveryInfo',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 查询物流信息
* @method logisticsInfo
* @param {string} deliveryCode 快递公司编码
* @param {string} expressNo 物流单号 (发货快递单号)
* @param {string} phone 收件人或寄件人的手机号或固话（顺丰单号必填，如果是固话，请不要上传分机号）
* @return {object} {code:0,msg:'',data:{}}
*
*/

const logisticsInfo = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/orderLogistics/v1/getLogisticsInfo',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 支付过后修改订单状态
* @method changeOrderState
* @param {string} outTradeNo 订单编号
* @param {string} orderStatus 订单状态 (0：未付款,1：商家确定,2：商家拒绝 4：已发货, 5：已签收, 6：退货申请, 7：退货中, 8：已退货(退款), 9：拒绝退款，10：取消交易, 11：已评价)
* @param {string} refuse 拒绝支付或拒绝退款理由
* @return {object} {code:0,msg:'',data:{}}
*
*/

const changeOrderState = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/savePayStatusInfo',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 邀请函
* @method inviteSubmit
* @param {string} register_name 姓名
* @param {string} register_phone 电话
* @param {string} register_email 邮箱
* @param {string} register_company_name 公司名称
* @param {string} register_position 职位
* @return {object} {code:0,msg:'',data:{}}
*
*/

const inviteSubmit = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/Conference/Register/v1/addOrEdit',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 群组视频
* @method getGroupVideoInfo
* @param {int} pageno 页码
* @param {int} count 一页的数量
* @param {String} groupId 群组ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const getGroupVideoInfo = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/getGroupVideoInfo',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 群组视频
* @method getGroupInfo
* @param {String} groupId 群组ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const getGroupInfo = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/rongcloud/v1/showGroupUser',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 邀请注册
* @method registerFriend
* @param {String} mobile 电话号码
* @param {String} smscode 验证码
* @param {fromuid} fromuid 邀请人
* @return {object} {code:0,msg:'',data:{}}
*
*/

const registerFriend = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/activity/v1/activityRegister',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 邀请注册活动详情
* @method registerFriendDetail
* @return {object} {code:0,msg:'',data:{}}
*
*/

const registerFriendDetail = () => {
return new Promise((resolve,reject) => {
axios.get('/lxdspservice/app/ssl/activity/v1/registerActivity').then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 商家评论列表
* @method shopCommitList
* @param CompanyOrTouristUid 被评价人的导游或商家ID
* @param pageno
* @param count
* @return {object} {code:0,msg:'',data:{}}
*
*/

const shopCommitList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/companyortouristcomment/v1/list',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 查询评论次数是否超限
* @method checkcommitShopTimes
* @param CompanyOrTouristUid 被评价人的导游或商家ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const checkcommitShopTimes = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/companyortouristcomment/v1/evaluator',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 查询评论次数是否超限
* @method commitShop
* @param uid 被评价人的导游或商家ID
* @param evaluatorUid 当前用户ID
* @param storeCommentGrade 店铺评价等级 1：非常不满意 2：不满意 3：满意 4：比较满意 5：非常满意
* @param anonymousComment 商品是否匿名评价 1：匿名 2：不匿名
* @param storeCommentContent 店铺评价内容
* @param storeCommentImages 商品评价图片
* @return {object} {code:0,msg:'',data:{}}
*
*/

const commitShop = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/companyortouristcomment/v1/save',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 旅居列表
* @method houseList
* @param pageno 当前页码
* @param count 一页多少条
* @param currentUid 用户ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const houseList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/house/v1/list',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 旅居列表
* @method forceHouseList
* @param houseId
* @param recordNumber (主力房型推荐)记录条数
* @return {object} {code:0,msg:'',data:{}}
*
*/

const forceHouseList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/house/v1/detail',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 推荐旅居列表
* @method recommendHouseList
* @param recordNumber (主力房型推荐)记录条数
* @return {object} {code:0,msg:'',data:{}}
*
*/

const recommendHouseList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/house/v1/recommend',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 发现视频接口
* @method findVideoList
* @param pageno 当前页码
* @param count 页数
* @return {object} {code:0,msg:'',data:{}}
*
*/

const findVideoList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/discovervideolist',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 定位城市发现视频接口
* @method findCityVideoList
* @param pageno 当前页码
* @param count 页数
* @param cid 城市ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const findCityVideoList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/video/v1/discoverCityVideolist',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 酒店列表
* @method hotelList
* @param pageno
* @param count
* @param cid
* @param hotelName
* @return {object} {code:0,msg:'',data:{}}
*
*/

const hotelList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/hotel/v1/list',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 酒店详情
* @method hotelDetail
* @param hotelId 酒店ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const hotelDetail = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/hotel/v1/selectHotelInfomation',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 酒店设施
* @method hotelFacility
* @param hotelId 酒店ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const hotelFacility = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/hotel/v1/selectHotelInstallation',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 酒店套餐查询
* @method hotelPackageList
* @param hotelId 酒店ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const hotelPackageList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/hotel/v1/selectHotelSetmealInfo',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 酒店套餐详情查询
* @method hotelPackageDetailList
* @param hotelId 酒店ID
* @param hotelSetmealId 套餐ID
* @return {object} {code:0,msg:'',data:{}}
*
*/

const hotelPackageDetailList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/hotel/v1/selectHotelSetmealDetailInfo',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 酒店推荐
* @method hotelRecommand
* @param count
* @param cid
* @return {object} {code:0,msg:'',data:{}}
*
*/

const hotelRecommand = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/hotel/v1/recommendList',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 酒店下单
* @method submitHotelOrder
* @param touristCompanyId 导游或企业ID
* @param touristCompanyName 导游或企业名称
* @param channelType 渠道类型 1:线路、2:商品、3:导游、4:特产 5：定制景点线路 6:酒店
* @param channelId 渠道ID
* @param channelName 渠道名称
* @param channelImage 渠道图片（多个图片之间用逗号分开）
* @param hotelMealId 套餐ID
* @param hotelMealName	套餐名称
* @param hotelMealDetailId 套餐详细ID
* @param tripNumber 入住天数
* @param sumCount 订房数量
* @param mealTime 入住时间
* @param hotelPrice 酒店价格
* @param linkName 联系人
* @param linkMobile 联系电话
* @param linkMail 联系人邮箱
* @param mark 买家留言
* @return {object} {code:0,msg:'',data:{}}
*
*/

const submitHotelOrder = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/hotelSave',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}



/**
* 查询某个用户的酒店
* @method hotelListByUser
* @param pageno
* @param count
* @param uid
* @return {object} {code:0,msg:'',data:{}}
*
*/

const hotelListByUser = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/hotel/v1/selectByUid',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 查询促销详细
* @method promotionInfomation
* @param promotionId 	促销商品id
* @param shareCurrentUid userLevel in (1,2) 时分享的时候带自己的id
* @return {object} {code:0,msg:'',data:{}}
*
*/

const promotionInfomation = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/promotion/v1/selectPromotionInfomation',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 根据退款规则ID查询规则
* @method promotionReturn
* @param returnRuleId
* @return {object} {code:0,msg:'',data:{}}
*
*/

const promotionReturn = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/returnRule/v1/selectByReturnRuleId',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

/**
* 促销商品分页查询
* @method promotionList
* @param pageno
* @param count
* @param cid
* @param shareCurrentUid userLevel in (1,2) 时分享的时候带自己的id
* @return {object} {code:0,msg:'',data:{}}
*
*/

const promotionList = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/promotion/v1/list',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 促销商品下单
* @method promotionSave
* @param touristCompanyId	是	Long	导游或企业ID
* @param touristCompanyName	是	String	导游或企业名称
* @param channelType	是	Byte	渠道类型 1:线路、2:商品、3:导游、4:特产 5：定制景点线路 6:酒店 7:促销商品(到店消费) 8:促销商品(需要发货)
* @param channelId	是	Long	渠道ID
* @param channelName	是	String	渠道名称
* @param channelImage	否	String	渠道图片（多个图片之间用逗号分开）
* @param promotionName	是	String	商品名称不能为空
* @param promotionSetmealId	是	Long	套餐ID不能为空
* @param promotionSetmealName	是	String	套餐名称不能为空
* @param promotionSalePrice	是	long	促销单价不能为空
* @param promotionUseDate	是	date	到店消费的使用日期(channelType=7 需要)
* @param sumCount	是	integer	购买数量不能为空
* @param linkName	是	String	联系人
* @param linkMobile	是	String	联系电话
* @param linkMail	否	String	联系人邮箱
* @param mark	否	String	买家留言
* @param consigneeRealname	是	String	收货人姓名 (channelType=8 需要)
* @param consigneeTelphone	是	String	联系电话 (channelType=8 需要)
* @param consigneeAddress	是	String	收货地址(channelType=8 需要)
* @param shareUid	是	Long	分享人用户ID(没有传空)
* @return {object} {code:0,msg:'',data:{}}
*
*/

const promotionSave = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/order/v1/promotionSave',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}


/**
* 商品选择日期
* @method promotionSelectDate
* @param promotionId
* @return {object} {code:0,msg:'',data:{}}
*/

const promotionSelectDate = (obj) => {
return new Promise((resolve,reject) => {
axios.post('/lxdspservice/app/ssl/promotion/v1/selectPromotionUseLimitationInfo',obj).then(res => {

resolve(res)
}).catch(err => {

reject(err)
})
})
}

export{
getProtocol,
aboutUs,
getSMS,
checkPhone,
checkPhoneAndSMS,
login,
videoDetail,
videoUrl,
lineDetail,
lineDetailDesc,
linePackage,
recommandList,
wxApi,
guideDetail,
goodsList,
getUserInfo,
getVideoList,
guideList,
travelType,
local,
travelList,
inSideCityList,
outSideCountyList,
outSideCityList,
countryCode,
wxlogin,
getTouristList,
actTourist,
delTourist,
submitOrder,
orderDetail,
indexList,
relatedVideo,
getCommit,
commitSubmit,
commitLike,
followUser,
getOrderList,
getOrderDetail,
videoLike,
uploadFiles,
getCircle,
bindPhone,
viewpointList,
themeList,
customeSubmit,
activityTicketList,
receiveTicket,
activityDetail,
commitList,
refundRule,
pwdLogin,
forget,
register,
getLxCodeUserInfo,
delOrder,
commitOrder,
refundAction,
refundRuleList,
preOrder,
alipay,
getVideoDetail,
getGuideList,
getGuideEnterList,
getCompanyList,
getCompanyEnterList,
getLineList,
getPartnerOrderList,
getPartnerRefundList,
getPartnerWithdrawList,
getMyAddressList,
delAddress,
editAddress,
getProvinceList,
getCityList,
goodsAllList,
goodsPackageList,
recommendGoods,
goodsDetail,
goodsDetailList,
goodsOrderSubmit,
orderDetail2,
getOrderDetail2,
logisticsCompany,
logisticsInfo,
userGoodsAllList,
inviteSubmit,
randomVideo,
getGroupInfo,
getGroupVideoInfo,
registerFriend,
registerFriendDetail,
shopCommitList,
checkcommitShopTimes,
commitShop,
houseList,
forceHouseList,
recommendHouseList,
findVideoList,
findCityVideoList,
changeOrderState,
hotelDetail,
hotelFacility,
hotelList,
hotelPackageList,
hotelPackageDetailList,
submitHotelOrder,
hotelRecommand,
hotelListByUser,
promotionInfomation,
promotionReturn,
promotionList,
promotionSave,
promotionSelectDate
}


// WEBPACK FOOTER //
// ./src/api/index.js